import React, {useEffect, useState} from "react";
import 'antd/dist/antd.min.css'; // or 'antd/dist/antd.less'
import './assets/style/main.css';
import DefaultLayout from './layout/index.js';
import Index from "./route";
import {useLocation} from 'react-router-dom';
import {getBrandSetting, getUrl} from "./service";
import {Helmet} from "react-helmet";
import Keys from "./_config";

function App() {

    const location = useLocation();

    const [urlPath, setUrlPath] = useState(false);
    const [brandSetting, setBrandSetting] = useState(false);

    const dispatchURL = () => {
        getUrl().then(async (response) => {
            let path = [];
            response.map((res) => {
                path.push(res.path)
            })
            setUrlPath(path)
        });
    };

    const dispatchBrandSetting = () => {
        getBrandSetting().then(async (response) => {
            if (response.list.length > 0) {
                setBrandSetting(response.list[0])
            }
        });
    };
    useEffect(() => {
        dispatchURL();
        dispatchBrandSetting();
    }, []);

    // Router settings
    if (location.pathname === "/admin/login" || location.pathname === "/admin/register" || location.pathname.split('/')[1] === "api" || urlPath && urlPath.includes(location.pathname) || location.pathname === "/") {
        return (
            <div className="App">
                <Helmet
                    link={[
                        {
                            "rel": "icon",
                            "href": Keys.SERVER_URL + brandSetting.faviconPath
                        }
                    ]}/>
                <Index/>
            </div>
        );
    } else if (location.pathname.split('/')[1] === "admin") {
        return (
            <DefaultLayout>
                <div className="App">
                    <Helmet
                        title={brandSetting.title}
                        link={[
                            {
                                "rel": "icon",
                                "href": Keys.SERVER_URL + brandSetting.faviconPath
                            }
                        ]}/>
                    <Index/>
                </div>
            </DefaultLayout>
        );

    }

    // End of Router settings
}

export default App;
